import React, { useState, useEffect } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
  useExpanded,
  useGlobalFilter,
  useRowSelect
} from "react-table";
import { Button } from "react-bootstrap";
// import MainTablePagination from "./MainTablePagination";
import { defaultVGMDataColumn } from "../cells/editable/VGMDataEditableCell";
import VGMActionCenter from "../action-center/VGMActionCenter";
import { VGM_DATA_COLUMNS } from "../../columns/VGMColumns";
import VGMPDFViewer from "../VGMPDFViewer";
import VGMAdd from "../VGMAdd";
import { filter } from "lodash";
import MainTablePaginationAdv from "./MainTablePaginationAdv";
import { TableCheckbox } from "./TableCheckbox";

function VGMDataTable({
  tableData,
  date,
  setDate,
  dataExportHandler,
  subModule,
  newSelectedFlatRows,
  setNewSelectedFlatRows,
  setTableData,
  filteredUserAccessData,
  noDataState,
  setNoDataState,
  personName
}) {
  const [columns] = useState(VGM_DATA_COLUMNS);
  const [showDisableCellForJD, setShowDisableCellForJD] = useState(false);
  const [showPDFModal, setShowPDFModal] = useState(null);
  const [showVGMAdd, setShowVGMAdd] = useState(null);

  var allowToAdd = filter(filteredUserAccessData,{Add:1}).length > 0
  var allowToEdit = filter(filteredUserAccessData,{Edit:1}).length > 0

  const updateCellData = (rowIndex, columnId, value) => {
    setTableData((old) =>
    old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      })
    );
  };

  const updateCellDataForWeighing_Date = (rowIndex, columnId, dateValue, timeValue) => {
    setTableData((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: `${dateValue}T${timeValue}`,
          };
        }
        return row;
      })
    );
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
    setPageSize,
    canPreviousPage,
    setGlobalFilter,
    prepareRow,
    selectedFlatRows,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data: tableData,
      // data,
      defaultColumn: defaultVGMDataColumn,
      autoResetPage: false,
      initialState: { pageSize: 50 },
      autoResetExpanded: false,
      autoResetGlobalFilter: false,
      showDisableCellForJD,
      setShowDisableCellForJD,
      updateCellData,
      updateCellDataForWeighing_Date,
      allowToEdit,
      personName
    },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <TableCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  useEffect(() => {
    setNewSelectedFlatRows(selectedFlatRows);
  }, [selectedFlatRows, setNewSelectedFlatRows]);

  const { pageIndex, pageSize, globalFilter } = state;

  const cellRenderHandler = (cell) => {
    if (cell.column.id === "generate_pdf") return "action";
    if (cell.column.id === "add_Data") return "addData";
    else return "data";
  };

  function downloadClickHandler(cell) {
    setShowPDFModal(cell);
  }

  function addVGMModalClickhandler(cell) {
    if (!cell.row.original.VGMId) {
      setShowVGMAdd(cell);
    } else setShowVGMAdd(null);
  }

  return (
    <>
      {showPDFModal && (
        <VGMPDFViewer
          date={date}
          show={showPDFModal}
          hide={() => setShowPDFModal(false)}
        />
      )}
      <div className="table_actions">
        {/* <Form.Group>
          <Form.Control
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="hiden-inp"
            placeholder="search here.."
          />
        </Form.Group> */}
        <VGMActionCenter
          date={date}
          setDate={setDate}
          dataExportHandler={dataExportHandler}
          tableData={tableData}
          selectedFlatRows={selectedFlatRows}
          subModule={subModule}
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          type={"Daily"}
          filteredUserAccessData={filteredUserAccessData}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          setNoDataState={setNoDataState}
        />
        {showVGMAdd && (
          <VGMAdd
            show={showVGMAdd}
            hide={() => setShowVGMAdd(null)}
            tableData={tableData}
            personName={personName}
          />
        )}
      </div>
      {!noDataState && (
        <>
          <div className="table_container">
            <table {...getTableProps()} className="table mtbs">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        {column.id !== "selection" && (
                          <i
                            className={
                              column.isSorted
                                ? column.isSortedDesc
                                  ? "fi fi-rr-angle-small-down head-icon"
                                  : "fi fi-rr-angle-small-up head-icon"
                                : "fi fi-rr-circle-small head-icon w"
                            }
                          ></i>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            className={
                              cell.row.subRows.length !== 0
                                ? "main-row"
                                : "sub-row"
                            }
                          >
                            <div className="cell-wrap">
                              {cellRenderHandler(cell) === "action" && (
                                <Button
                                  className="VGMPDFBtn"
                                  disabled={!cell.row.original.VGMId}
                                  onClick={() => downloadClickHandler(cell)}
                                >
                                  <i
                                    class="bx bxs-file-pdf"
                                    style={{
                                      color: `${
                                        cell.row.original.VGMId ? "red" : "gray"
                                      }`,
                                      background: "transparent",
                                      transform: "scale(1.8)",
                                      // marginLeft: "30px",
                                      cursor: "pointer",
                                    }}
                                  ></i>
                                </Button>
                              )}
                              {cellRenderHandler(cell) === "addData" && (
                                <Button
                                  className="btn btn-sm btn-tbl"
                                  style={{
                                    height: "35px",
                                    marginRight: "40px",
                                  }}
                                  onClick={() => addVGMModalClickhandler(cell)}
                                  disabled={
                                    cell.row.original.VGMId || !allowToAdd
                                  }
                                >
                                  <i class="bx bx-add-to-queue uploadSymbol"></i>
                                </Button>
                              )}
                              {cellRenderHandler(cell) === "data" &&
                                cell.render("Cell")}
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* <MainTablePagination
        nextPage={nextPage}
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        setPageSize={setPageSize}
      /> */}
          <MainTablePaginationAdv
            nextPage={nextPage}
            previousPage={previousPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            canPreviousPage={canPreviousPage}
            setPageSize={setPageSize}
            gotoPage={gotoPage}
            pageCount={pageCount}
          />
        </>
      )}
    </>
  );
}

export default VGMDataTable;
